import { render } from "./InputNumber.vue?vue&type=template&id=e0b227a6&scoped=true"
import script from "./InputNumber.vue?vue&type=script&lang=js"
export * from "./InputNumber.vue?vue&type=script&lang=js"

import "./InputNumber.vue?vue&type=style&index=0&id=e0b227a6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b227a6"]])

export default __exports__